// extracted by mini-css-extract-plugin
module.exports = {"large":"FoodName_large__3GaDY","small":"FoodName_small__wFT9o","component":"FoodName_component__15JR2","supplementary":"FoodName_supplementary__1mY9a"};